// A "last N prompts" page (CYBORG-1180) sends a run of rows as ONE item listing the other
// seqs it stands for in `coalescedSeqs`. Expand it back to one row per seq so the store's
// seq dedupe, applied set and chunk joins see exactly the rows an ordinary page carries.
// A text row keeps its whole text on its first seq and "" on the rest; any other row
// (a tool call's latest state) repeats on every seq, which the store applies in place.

const TEXT_TYPES = new Set(["assistant_message", "reasoning"]);

function coalescedSeqsOf(item: Record<string, unknown>): number[] | null {
  const seqs = item.coalescedSeqs;
  if (!Array.isArray(seqs) || seqs.length === 0) return null;
  return seqs.filter((s): s is number => typeof s === "number");
}

export function expandCoalescedRows(items: Record<string, unknown>[]): Record<string, unknown>[] {
  if (!items.some((item) => coalescedSeqsOf(item) !== null)) return items;
  const out: Record<string, unknown>[] = [];
  for (const item of items) {
    const seqs = coalescedSeqsOf(item);
    if (seqs === null) {
      out.push(item);
      continue;
    }
    const base = { ...item };
    delete base.coalescedSeqs;
    out.push(base);
    const isText = TEXT_TYPES.has(String(base.type));
    for (const seq of seqs) out.push(isText ? { ...base, text: "", seq } : { ...base, seq });
  }
  const seqOf = (row: Record<string, unknown>) =>
    typeof row.seq === "number" ? row.seq : Number.POSITIVE_INFINITY;
  return out.toSorted((a, b) => seqOf(a) - seqOf(b));
}
